/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Sector_PlaceholderInputs */

const en_company_profile_sector_placeholder = /** @type {(inputs: Company_Profile_Sector_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry/Sector`)
};

const de_company_profile_sector_placeholder = /** @type {(inputs: Company_Profile_Sector_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industrie/Sektor`)
};

/**
* | output |
* | --- |
* | "Industry/Sector" |
*
* @param {Company_Profile_Sector_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_sector_placeholder = /** @type {((inputs?: Company_Profile_Sector_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Sector_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_sector_placeholder(inputs)
	return en_company_profile_sector_placeholder(inputs)
});